module.exports = __webpack_public_path__ + "img/US_MaxHealth_ua.544be8ce.webp";